<template>
    <div>
        <div style="max-width: 500px">
            <template v-for="registrant in sortedRegistrants">
                <div class="mb-4">
                    <Field :name="fieldName(registrant)" :errors="errors" v-slot="{ error }">
                        <RegistrantCard :registrant="registrant" :order="order" :error="error">
                            <template v-if="registrant.registration_answer_id">
                                <FormojAnswer
                                    class="m-0"
                                    :answer-id="registrant.registration_answer_id"
                                    appearance="default"
                                    :key="answerKey(registrant)"
                                >
                                    <template v-slot:footer>
                                        <button class="btn btn-outline-primary border-0 btn-sm" @click="handleEditClicked(registrant)">
                                            Modifier...
                                        </button>
                                    </template>
                                </FormojAnswer>
                            </template>
                            <template v-else>
                                <div class="alert alert-warning mx-n2 mt-n2" style="font-size: .875rem">
                                    le formulaire d’inscription de cet inscrit n’a pas encore été rempli, cliquez sur le bouton ci-dessous
                                </div>
                                <button class="btn btn-outline-primary border-0" @click="handleEditClicked(registrant)">
                                    Remplir le formulaire...
                                </button>
                            </template>
                        </RegistrantCard>
                    </Field>
                </div>
            </template>
        </div>

        <b-modal
            dialog-class="cursus-register__form-modal"
            :visible="!!editingRegistrant"
            title="Formulaire d'inscription"
            hide-footer
            no-close-on-backdrop
            @hide="editingRegistrant = null"
        >
            <template v-slot:modal-title>
                Inscription
                <template v-if="editingRegistrant">
                    de {{ editingRegistrant.first_name }} {{ editingRegistrant.last_name }}
                </template>
            </template>

            <template v-slot:default="{ visible, hide }">
                <!-- display all errors if any -->
                <Field class="mb-0" :errors="editingErrors" v-slot="{ error }">
                    <template v-if="error">
                        Une erreur est survenue lors de l'inscription :
                    </template>
                    <template v-else-if="editingRegistrant">
                        <Formoj
                            class="cursus-formoj m-0"
                            :form-id="course.registration_form_id"
                            :answer-id="editingRegistrant.registration_answer_id"
                            show-cancel
                            submit-button-label="Valider"
                            appearance="default"
                            @success="handleFormSuccess"
                            @cancel="hide"
                        />
                    </template>
                </Field>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import { Formoj, FormojAnswer } from 'formoj';
    import { postOrderFormRegistrant } from "../../../../api";
    import Field from "../../../Field";
    import RegistrantSections from "../../RegistrantSections";
    import RegistrantCard from "../../RegistrantCard";
    import { errorsExcept } from "../../../../util/form";
    import { registrantIndex, sortRegistrants } from "../../../../util/register";

    export default {
        components: {
            RegistrantCard,
            RegistrantSections,
            Formoj,
            FormojAnswer,
            Field,
        },
        props: {
            order: Object,
            course: Object,
            errors: Object,
        },
        data() {
           return {
               loading: false,
               editingErrors: null,
               editingRegistrant: null,
               updateKeys: {},
           }
        },
        computed: {
            sortedRegistrants() {
                return sortRegistrants(this.order.registrants);
            },
        },
        methods: {
            handleFormSuccess(formojResponse) {
                const { courseId, sessionId, orderId } = this.$route.params;
                this.loading = true;
                this.editingErrors = null;
                postOrderFormRegistrant({
                    courseId, sessionId, orderId, registrantId: this.editingRegistrant.id,
                    data: {
                        ...this.editingRegistrant,
                        registration_answer_id: formojResponse.answer_id,
                    }
                })
                .then(order => {
                    this.$emit('update:order', order);
                    this.updateErrors(this.editingRegistrant);
                    this.handleFormUpdated(this.editingRegistrant);
                    this.editingRegistrant = null;
                })
                .catch(error => {
                    if(error.response?.status === 422) {
                        this.editingErrors = error.response.data.errors;
                    } else {
                        this.editingErrors = {
                            message: "Impossible de valider l’inscription pour le moment, veuillez réessayer plus tard",
                        }
                        return Promise.reject(error);
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
            },
            handleEditClicked(registrant) {
                this.editingErrors = null;
                this.editingRegistrant = {
                    ...registrant,
                }
            },
            fieldName(registrant) {
                const i = registrantIndex(this.order.registrants, registrant);
                return `registrants.${i}`;
            },
            answerKey(registrant) {
                return `${registrant.id}-${this.updateKeys[registrant.id] ?? 0}`;
            },
            handleFormUpdated(registrant) {
                let key = this.updateKeys[registrant.id] ?? 0;
                this.updateKeys = {
                    ...this.updateKeys,
                    [registrant.id]: ++key,
                }
            },
            updateErrors(editingRegistrant) {
                const index = this.order.registrants.findIndex(r => r.id === editingRegistrant.id)
                this.$emit('update:errors', errorsExcept(this.errors, `registrants.${index}`));
            },
        }
    }
</script>
